export const NAV_ROW_HEIGHT = 52;
export const CONTENT_ANCHOR_ID = 'menu-content';
export const PRIORITY_IMAGE_COUNT = 6;
export const CARD_IMAGE_TRANSFORM = 'w-244,h-244,cm-maintain_ratio';
export const HERO_IMAGE_TRANSFORM = 'w-1200,q-70,f-auto';
